import { render, staticRenderFns } from "./DiscountCoupon.vue?vue&type=template&id=9d21e0c6&scoped=true"
import script from "./DiscountCoupon.vue?vue&type=script&lang=js"
export * from "./DiscountCoupon.vue?vue&type=script&lang=js"
import style0 from "./DiscountCoupon.vue?vue&type=style&index=0&id=9d21e0c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d21e0c6",
  null
  
)

export default component.exports